/**
 * Whole seconds until a server `deadline`, rounded up and never negative.
 * `offset` is `serverNow - Date.now()` (see `clockOffset`), so `now + offset` is server time.
 */
export function secondsLeft(deadline: number | null, now: number, offset: number): number {
  if (deadline === null) return 0;
  return Math.max(0, Math.ceil((deadline - (now + offset)) / 1000));
}
